<ng-container *transloco="let t">
  <section
    id="footer-expert-contact"
    class="bg-ld-neutral-100 shadow-[0_-2px_4px_rgba(0,0,0,0.15)] w-full flex justify-center"
    [attr.aria-label]="t('footerExpertContactAriaLabel')"
  >
    <div
      id="footer-expert-contact-container"
      class="w-full max-w-[1440px] mx-auto min-h-24 py-4 pb-6 px-[72px] flex items-center justify-between gap-10 max-xl:px-12 max-lg:flex-col max-lg:items-start max-lg:gap-6 max-lg:p-6"
    >
      <div
        id="footer-expert-contact-profile"
        class="flex items-center gap-8 max-sm:flex-col max-sm:items-start max-sm:gap-4"
      >
        <div
          id="footer-expert-contact-avatar"
          class="w-[120px] h-[120px] bg-ld-lime rounded-[32px] flex items-center justify-center relative"
          aria-hidden="true"
        >
          <div id="footer-expert-contact-avatar-ring" class="w-[106px] h-[106px] rounded-full overflow-hidden">
            <img
              id="footer-expert-contact-avatar-image"
              [src]="expert.headshotSrc"
              [alt]="expert.headshotAlt"
              class="w-full h-full object-cover"
            />
          </div>
        </div>
        <div id="footer-expert-contact-identity" class="flex flex-col gap-0.5">
          <p id="footer-expert-contact-name" class="font-dm text-[28px] leading-9 font-semibold text-ld-neutral m-0">
            {{ expert.name }}
          </p>
          <div id="footer-expert-contact-role-meta" class="flex gap-4 text-sm leading-5 tracking-[0.28px]">
            <p id="footer-expert-contact-role" class="font-general font-semibold text-ld-primary m-0">
              {{ expert.role }}
            </p>
            <p id="footer-expert-contact-nmls" class="font-general font-normal text-ld-neutral-500 m-0">
              {{ t('commonLabelsNmls') }}{{ expert.nmlsId }}
            </p>
          </div>
        </div>
      </div>

      <div
        id="footer-expert-contact-channels"
        class="flex items-center gap-28 max-lg:w-full max-lg:flex-wrap max-lg:gap-8 max-sm:flex-col max-sm:items-start max-sm:gap-4"
        [attr.aria-label]="t('footerExpertContactContactMethodsAriaLabel')"
      >
        <div
          id="footer-expert-contact-channel-phone"
          class="flex items-center gap-2 font-general text-base leading-5 text-ld-neutral"
        >
          <ld-svg-icon
            id="footer-expert-contact-phone-icon"
            [src]="phoneIconSrc"
            aria-hidden="true"
            class="w-4 h-4 shrink-0"
          />
          <a id="footer-expert-contact-phone-link" class="text-inherit no-underline hover:underline" [href]="phoneHref">
            {{ expert.phoneNumber }}
          </a>
        </div>
        <div
          id="footer-expert-contact-channel-email"
          class="flex items-center gap-2 font-general text-base leading-5 text-ld-neutral"
        >
          <ld-svg-icon
            id="footer-expert-contact-email-icon"
            [src]="envelopeIconSrc"
            aria-hidden="true"
            class="w-4 h-4 shrink-0"
          />
          <a
            id="footer-expert-contact-email-link"
            class="text-inherit no-underline hover:underline"
            [href]="expert.emailHref"
          >
            {{ expert.emailLabel }}
          </a>
        </div>
        @if (hasAddress) {
          <div
            id="footer-expert-contact-channel-address"
            class="flex items-center gap-2 font-general text-base leading-5 text-ld-neutral"
          >
            <ld-svg-icon
              id="footer-expert-contact-location-icon"
              [src]="locationIconSrc"
              aria-hidden="true"
              class="w-4 h-4 shrink-0"
            />
            <div id="footer-expert-contact-address" class="text-sm leading-4" role="text">
              @for (line of expert.addressLines; track line) {
                <p class="m-0">
                  {{ line }}
                </p>
              }
            </div>
          </div>
        }
        @if (expert.showShareScreen) {
          <div
            id="footer-expert-contact-channel-share-screen"
            class="flex items-center gap-2 font-general text-base leading-5 text-ld-neutral"
            [class.opacity-60]="isShareScreenLoading()"
            [class.pointer-events-none]="isShareScreenLoading()"
          >
            @if (isShareScreenLoading()) {
              <mat-spinner diameter="16" class="inline-block" />
            } @else {
              <ld-svg-icon
                id="footer-expert-contact-share-screen-icon"
                [src]="shareScreenIconSrc"
                aria-hidden="true"
                class="w-4 h-4 shrink-0"
              />
            }
            <a
              id="footer-expert-contact-share-screen-link"
              class="text-inherit no-underline hover:underline cursor-pointer"
              (click)="onShareScreenClick()"
              (keydown.enter)="onShareScreenClick()"
              [attr.tabindex]="isShareScreenLoading() ? -1 : 0"
              [attr.aria-disabled]="isShareScreenLoading()"
              role="button"
            >
              {{ t('shareMyScreen') }}
            </a>
          </div>
        }
      </div>
    </div>
  </section>
</ng-container>
